import { Col, Row } from 'react-bootstrap';

import { useComponentWillUnmount } from 'modules/core/hooks';
import { ClientSearchByNameForm } from './ClientSearchByNameFormValues';
import { ClientSearchByNameResult } from './ClientSearchByNameResult';
import { clientActions } from '../store/clientStore';

const ClientSearchByName = () => {
  useComponentWillUnmount(() => {
    clientActions.clearClientsFoundByName();
  });

  return (
    <>
      <Row>
        <Col md={ 12 }>
          <ClientSearchByNameForm />
        </Col>
      </Row>
      <Row>
        <Col md={ 6 }>
          <ClientSearchByNameResult />
        </Col>
      </Row>
    </>
  );
};

export { ClientSearchByName };
